/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star': {
    width: 16,
    height: 16,
    viewBox: '0 0 31.999 31.999',
    data: '<path pid="0" d="M31.881 12.056a2.303 2.303 0 0 0-1.844-1.511l-8.326-1.238-3.619-7.514A2.318 2.318 0 0 0 16 .499c-.896 0-1.711.505-2.092 1.294l-3.619 7.514-8.327 1.238A2.3 2.3 0 0 0 .12 12.056a2.207 2.207 0 0 0 .537 2.285l6.102 6.092-1.415 8.451a2.224 2.224 0 0 0 .948 2.203 2.351 2.351 0 0 0 2.449.131L16 27.31l7.26 3.908a2.367 2.367 0 0 0 2.449-.131 2.225 2.225 0 0 0 .947-2.203l-1.416-8.451 6.104-6.092c.603-.603.81-1.485.537-2.285zm-8.293 6.806a2.216 2.216 0 0 0-.627 1.934l1.416 8.451-7.26-3.906a2.361 2.361 0 0 0-2.235 0l-7.26 3.906 1.416-8.451a2.212 2.212 0 0 0-.626-1.934L2.31 12.77l8.326-1.24a2.306 2.306 0 0 0 1.743-1.268L16 2.75l3.62 7.513a2.31 2.31 0 0 0 1.742 1.268l8.328 1.24-6.102 6.091z" _fill="#010002"/>'
  }
})
